import { render, staticRenderFns } from "./LandingServices.vue?vue&type=template&id=3b82f0ba&scoped=true"
import script from "./LandingServices.vue?vue&type=script&lang=js"
export * from "./LandingServices.vue?vue&type=script&lang=js"
import style0 from "./LandingServices.vue?vue&type=style&index=0&id=3b82f0ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b82f0ba",
  null
  
)

export default component.exports